import Base from "../Base";
import Message from "../Messages/Message";
import ChatTypes from "../../enums/ChatTypes";

export default class NewRoom extends Base {
    title;
    subtitle;
    type;
    members = [];
    notifications = true;
    groupId = undefined;

    constructor(data) {
        super();
        this.setUp(this, data);
    }

    /**
     *
     * @param user {Profile}
     * @returns {NewRoom}
     */
    static directRoom(user) {
        return new NewRoom({
           title: user.fullName(),
           subtitle: '',
           type: ChatTypes.direct,
           members: [user.userId]
        });
    }

    /**
     *
     * @param user {Profile}
     * @returns {NewRoom}
     */
    static getPrivateGroup(membersUserIds, title) {
        return new NewRoom({
            title: title,
            subtitle: '',
            type: ChatTypes.privateGroup,
            members: membersUserIds
        });
    }
}